import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetRevenueEntryAccess } from 'queries/revenue-entries/use-revenue-entries-access';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { NotFoundPage, RevenueEntryRoutes } from 'routes/vendor/lazy-imports';
const RevenueEntryRoutesLayout = ({ children })=>{
    const { data: access, isInitialLoading } = useGetRevenueEntryAccess();
    if (isInitialLoading) {
        return null;
    }
    // User should have access to view revenue entries
    if (access === null || access === void 0 ? void 0 : access.canView) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(NotFoundPage, {});
};
export const revenueEntryRoutes = {
    path: `${ROUTE_PATHS.REVENUE_ENTRIES}/${ROUTE_PATHS.MATCH_ALL}`,
    element: /*#__PURE__*/ _jsx(SecureRoute, {
        children: /*#__PURE__*/ _jsx(RevenueEntryRoutesLayout, {
            children: /*#__PURE__*/ _jsx(RevenueEntryRoutes, {})
        })
    })
};
